import {
  Checkbox,
  Flex,
  FormControl,
  FormErrorMessage,
  Text,
} from "@chakra-ui/react";
import { FC } from "react";

interface CheckboxComponentProps {
  name: string;
  register: any;
  errors: any;
  isRequired?: boolean;
  isDisabled?: boolean;
  description?: string;
}

const CheckboxComponent: FC<CheckboxComponentProps> = ({
  name,
  register,
  errors,
  isRequired = false,
  isDisabled = false,
  description,
}) => {
  return (
    <Flex gap={2.5} alignItems="flex-end">
      <FormControl isInvalid={!!errors[name]}>
        <Checkbox
          isDisabled={isDisabled}
          {...(isRequired && { isRequired })}
          {...register(name)}
        >
          <Text>{description}</Text>
        </Checkbox>
        <FormErrorMessage>
          {errors[name] && errors[name].message}
        </FormErrorMessage>
      </FormControl>
    </Flex>
  );
};

export default CheckboxComponent;
